(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["broek-collection-subnav"] && !Shopify.designMode) return;
  try {
    
(()=>{
  // Tapping the active chip clears the filter (replaces the old "All items" button).
  document.addEventListener('click', event => {
    const chip = event.target.closest && event.target.closest('.bx-subnav .bx-chip');
    if (!chip || chip.getAttribute('aria-current') !== 'true') return;
    const reset = chip.closest('.bx-subnav').querySelector('.bx-subnav__reset');
    if (!reset) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    reset.click();
  }, true);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["broek-offer-announcement"]) return;
  try {
    

(function () {
  'use strict';
  if (!window.customElements || customElements.get('broek-campaign-countdown')) return;
  class BroekOfferCountdown extends HTMLElement {
    connectedCallback() {
      this.end = Date.parse(this.dataset.end);
      this.activeLink = this.querySelector('[data-offer-active]');
      this.endedLink = this.querySelector('[data-offer-ended]');
      this.clock = this.querySelector('[data-offer-clock]');
      this.days = this.querySelector('[data-clock-days]');
      this.hours = this.querySelector('[data-clock-hours]');
      this.minutes = this.querySelector('[data-clock-minutes]');
      this.seconds = this.querySelector('[data-clock-seconds]');
      this.section = this.closest('.broek-countdown-header');
      this.updateBound = this.update.bind(this);
      this.resizeBound = this.measure.bind(this);
      this.visibilityBound = () => { if (!document.hidden) this.update(); else clearTimeout(this.timer); };
      window.addEventListener('pageshow', this.updateBound);
      window.addEventListener('resize', this.resizeBound, { passive: true });
      document.addEventListener('visibilitychange', this.visibilityBound);
      if (window.ResizeObserver) {
        this.observer = new ResizeObserver(this.resizeBound);
        this.observer.observe(this);
      }
      this.update();
      this.measure();
    }
    measure() {
      if (!this.isConnected) return;
      const height = Math.ceil((this.section || this).getBoundingClientRect().height);
      const value = height + 'px';
      if (document.documentElement.style.getPropertyValue('--broek-offer-bar-height') !== value) {
        document.documentElement.style.setProperty('--broek-offer-bar-height', value);
      }
    }
    update() {
      clearTimeout(this.timer);
      if (!this.isConnected || !this.activeLink || !this.endedLink) return;
      const remaining = Number.isFinite(this.end) ? Math.max(0, Math.ceil((this.end - Date.now()) / 1000)) : 0;
      const active = remaining > 0;
      const hadFocus = document.activeElement === this.activeLink;
      if (this.activeLink.hidden === active) this.activeLink.hidden = !active;
      if (this.endedLink.hidden !== active) this.endedLink.hidden = active;
      if (!active) {
        if (hadFocus) this.endedLink.focus({ preventScroll: true });
        this.measure();
        return;
      }
      const days = Math.floor(remaining / 86400);
      const hours = Math.floor((remaining % 86400) / 3600);
      const minutes = Math.floor((remaining % 3600) / 60);
      const seconds = remaining % 60;
      [[this.days, days], [this.hours, hours], [this.minutes, minutes], [this.seconds, seconds]].forEach(([node, number]) => {
        const value = String(number).padStart(2, '0');
        if (node && node.textContent !== value) node.textContent = value;
      });
      if (this.clock) this.clock.setAttribute('aria-label', days + ' days, ' + hours + ' hours, ' + minutes + ' minutes, ' + seconds + ' seconds remaining');
      if (!document.hidden) this.timer = window.setTimeout(this.updateBound, 1000);
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      if (this.observer) this.observer.disconnect();
      window.removeEventListener('pageshow', this.updateBound);
      window.removeEventListener('resize', this.resizeBound);
      document.removeEventListener('visibilitychange', this.visibilityBound);
      if (!document.querySelector('broek-campaign-countdown')) document.documentElement.style.removeProperty('--broek-offer-bar-height');
    }
  }
  customElements.define('broek-campaign-countdown', BroekOfferCountdown);
}());


(()=>{
  function bindAnnouncements(){
    document.querySelectorAll('[data-bv3-announcement]').forEach(host=>{
      if(host.dataset.bound)return;host.dataset.bound='true';
      const messages=[...host.querySelectorAll('[data-bv3-ann-message]')];
      let index=0,paused=matchMedia('(prefers-reduced-motion:reduce)').matches;
      const show=n=>{index=(n+messages.length)%messages.length;messages.forEach((message,i)=>message.hidden=i!==index)};
      host.querySelector('[data-bv3-ann-prev]').addEventListener('click',()=>show(index-1));
      host.querySelector('[data-bv3-ann-next]').addEventListener('click',()=>show(index+1));
      const timer=setInterval(()=>{if(!host.isConnected){clearInterval(timer);return}if(!paused&&!document.hidden&&!host.matches(':hover,:focus-within'))show(index+1)},5000);
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',bindAnnouncements,{once:true});else bindAnnouncements();
  document.addEventListener('shopify:section:load',bindAnnouncements);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["broek-product-reviews"] && !Shopify.designMode) return;
  try {
    
(() => {
  const start = () => document.querySelectorAll('[data-product-review-carousel]').forEach(root => {
    const widget = root.querySelector('[data-bpr-entry-point]');
    if (!widget || root.dataset.bprBound) return;
    root.dataset.bprBound = '1';
    let pending = false, attempts = 0;
    async function load() {
      if (pending || widget.hasAttribute('data-entry-point')) return;
      const base = window.jdgm && window.jdgm.CDN_BASE_URL;
      if (!base) { if (attempts++ < 20) setTimeout(load, 300); return; }
      pending = true;
      attempts++;
      try {
        const response = await fetch(base + 'manifest.json');
        if (!response.ok) throw new Error('Review styles unavailable');
        const manifest = await response.json();
        const seen = new Set(), styles = new Set();
        const visit = key => {
          if (seen.has(key)) return;
          seen.add(key);
          const entry = manifest[key];
          if (!entry) return;
          (entry.css || []).forEach(file => styles.add(base + file));
          (entry.imports || []).forEach(visit);
        };
        visit(widget.dataset.entryKey);
        await Promise.all([...styles].map(href => new Promise(resolve => {
          if ([...document.querySelectorAll('link[rel="stylesheet"]')].some(link => link.href === href)) return resolve();
          const link = document.createElement('link');
          link.rel = 'stylesheet'; link.href = href;
          link.onload = resolve; link.onerror = resolve; document.head.append(link); setTimeout(resolve, 5000);
        })));
        widget.dataset.entryPoint = widget.dataset.bprEntryPoint;
        const script = document.createElement('script');
        script.type = 'module'; script.src = base + widget.dataset.entryPoint;
        script.onerror = () => { widget.removeAttribute('data-entry-point'); pending = false; if (attempts < 3) setTimeout(load, 1000); };
        document.head.append(script);
      } catch (_) { pending = false; if (attempts < 3) setTimeout(load, 1000); }
    }
    if (!('IntersectionObserver' in window) || /judgeme|reviews/.test(location.hash)) load();
    else {
      const observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) { load(); observer.disconnect(); }
      }, {rootMargin:'600px'});
      observer.observe(root);
    }
    root.addEventListener('focusin', load);
    root.addEventListener('pointerdown', load, {passive:true});
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true}); else start();
  document.addEventListener('shopify:section:load', start);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["broek-v3-runtime"]) return;
  try {
    
(()=>{
 'use strict';if(window.BroekV3)return;window.BroekV3=true;
 const root=window.Shopify?.routes?.root||'/',copy=JSON.parse(document.querySelector('[data-bv3-messages]')?.textContent||'{}');
 const parse=html=>new DOMParser().parseFromString(html,'text/html');
 const money=c=>'LE '+new Intl.NumberFormat('en-US',{maximumFractionDigits:0}).format(Math.round(c/100));
 const request=async url=>{const response=await fetch(url,{credentials:'same-origin'});if(!response.ok)throw new Error('Request failed');return response.text()};
 const closeMenu=()=>{const menu=document.getElementById('bv3-menu');if(menu?.open)menu.close()};
 window.addEventListener('click',event=>{const target=event.target.closest?.('[data-action="bv3-toggle-nav"]');if(!target||!matchMedia('(max-width:1024px)').matches)return;const menu=document.getElementById('bv3-menu');if(menu){event.preventDefault();event.stopImmediatePropagation();menu.showModal()}},true);
 document.addEventListener('click',async event=>{
  const reviewButton=event.target.closest('[data-bv3-review-prev],[data-bv3-review-next]');if(reviewButton){const host=reviewButton.closest('[data-bv3-reviews]'),arrows=host.querySelectorAll('.jdgm-arrows--bottom .jdgm-arrow');arrows[reviewButton.hasAttribute('data-bv3-review-next')?1:0]?.click();return}
  const close=event.target.closest('[data-bv3-close-menu]');if(close){closeMenu();return}
  if(event.target.closest('#bv3-menu a'))closeMenu();
  const swatch=event.target.closest('[data-bv3-swatch]');
  if(swatch){if(event.ctrlKey||event.metaKey)return;event.preventDefault();const card=swatch.closest('[data-bv3-card]');if(card.getAttribute('aria-busy')==='true')return;card.setAttribute('aria-busy','true');try{const url=new URL(swatch.href);url.searchParams.set('section_id','broek-v3-card');const next=parse(await request(url)).querySelector('[data-bv3-card]');if(!next)throw new Error('Missing product');card.replaceWith(next)}catch(_){location.assign(swatch.href)}return}
  const colour=event.target.closest('[data-bv3-look-colour]');
  if(colour){event.preventDefault();const piece=colour.closest('[data-bv3-piece]');if(piece.getAttribute('aria-busy')==='true')return;piece.setAttribute('aria-busy','true');try{const url=new URL(colour.href);url.searchParams.set('section_id','broek-v3-look-piece');const next=parse(await request(url)).querySelector('[data-bv3-piece]');if(!next)throw new Error('Missing product');next.querySelector('[data-bv3-include]').checked=piece.querySelector('[data-bv3-include]').checked;const form=piece.closest('form'),previousUrl=piece.dataset.productUrl;piece.replaceWith(next);const image=next.querySelector('img'),host=form.closest('[data-bv3-look]'),slot=[...host.querySelectorAll('[data-bv3-paired-photo]')].find(x=>x.dataset.productUrl===previousUrl),main=slot?.querySelector('img')||host.querySelector('[data-bv3-look-main] img');if(image&&main){const fullImage=new URL(image.src);fullImage.searchParams.set('width','800');main.src=fullImage.href;main.removeAttribute('srcset');main.alt=image.alt;if(slot)slot.dataset.productUrl=next.dataset.productUrl}total(form)}catch(_){piece.removeAttribute('aria-busy');piece.closest('form').querySelector('[data-bv3-error]').textContent=copy.error}return}
  const open=event.target.closest('[data-bv3-open-look]');if(open){event.preventDefault();const url=new URL(location.href);url.searchParams.set('look',open.dataset.bv3OpenLook);history.pushState({},'',url);showLook();return}
  if(event.target.closest('[data-bv3-all-looks]')){const url=new URL(location.href);url.searchParams.delete('look');history.pushState({},'',url);showLook();return}
  const photo=event.target.closest('[data-bv3-look-photo]');if(photo){const image=photo.closest('[data-bv3-look]').querySelector('[data-bv3-look-main] img');image.src=photo.dataset.bv3LookPhoto;image.removeAttribute('srcset');image.alt=photo.getAttribute('aria-label')}
 });
 document.addEventListener('keydown',e=>{if(e.target.matches('.bv3-eye')&&(e.key==='Enter'||e.key===' ')){e.preventDefault();e.target.click()}});
 function total(form){let cents=0;form.querySelectorAll('[data-bv3-piece]').forEach(piece=>{if(piece.querySelector('[data-bv3-include]').checked){const select=piece.querySelector('[data-bv3-variant]');cents+=Number(select.selectedOptions[0]?.dataset.price||piece.querySelector('[data-bv3-base-price]').value)}});form.querySelector('[data-bv3-total]').textContent=(copy.selectedTotal||'Selected pieces')+': '+money(cents)}
 document.addEventListener('change',e=>{const form=e.target.closest('[data-bv3-look-form]');if(form){form.querySelector('[data-bv3-error]').textContent='';total(form)}});
 document.addEventListener('submit',async e=>{const form=e.target.closest('[data-bv3-look-form]');if(!form)return;e.preventDefault();const pieces=[...form.querySelectorAll('[data-bv3-piece]')].filter(p=>p.querySelector('[data-bv3-include]').checked),error=form.querySelector('[data-bv3-error]'),button=form.querySelector('button[type=submit]');if(button.disabled)return;error.textContent='';if(!pieces.length){error.textContent=copy.choosePiece;return}const invalid=pieces.find(p=>!p.querySelector('[data-bv3-variant]').value||p.getAttribute('aria-busy')==='true');if(invalid){error.textContent=copy.chooseSizes;invalid.querySelector('select').focus();return}const items=pieces.map(p=>({id:Number(p.querySelector('select').value),quantity:1}));const label=button.textContent;button.disabled=true;button.textContent=copy.adding;try{const response=await fetch(root+'cart/add.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json'},body:JSON.stringify({items})});const result=await response.json();if(!response.ok)throw new Error(result.description||copy.error);location.assign(root+'cart')}catch(err){error.textContent=err.message||copy.error;window.BroekClaudeUI?.refresh?.();button.disabled=false;button.textContent=label}});
 function showLook(){const host=document.querySelector('[data-bv3-looks][data-gallery=true]');if(!host)return;const key=new URL(location.href).searchParams.get('look');const selected=[...host.querySelectorAll('[data-bv3-look]')].find(x=>x.dataset.bv3Look===key);host.querySelector('[data-bv3-look-grid]').hidden=!!selected;host.querySelector('.bv3-section-head').hidden=!!selected;host.querySelectorAll('[data-bv3-look]').forEach(x=>x.hidden=x!==selected);if(selected)selected.querySelector('h1').scrollIntoView({block:'start',behavior:'instant'})}
 window.addEventListener('popstate',showLook);
 function setupHero(hero){if(hero.dataset.bv3Bound)return;hero.dataset.bv3Bound='1';const slides=[...hero.querySelectorAll('[data-bv3-slide]')],dots=[...hero.querySelectorAll('[data-bv3-dot]')],pause=hero.querySelector('[data-bv3-pause]');if(!slides.length)return;let idx=0,elapsed=0,last=performance.now(),paused=matchMedia('(prefers-reduced-motion:reduce)').matches,down=null,dragged=false;const show=n=>{idx=(n+slides.length)%slides.length;elapsed=0;slides.forEach((s,i)=>s.hidden=i!==idx);dots.forEach((d,i)=>{d.setAttribute('aria-pressed',String(i===idx));d.querySelector('.bv3-ring').style.strokeDashoffset=44})};const sync=()=>{pause.textContent=paused?'▶':'Ⅱ';pause.setAttribute('aria-pressed',String(paused));pause.setAttribute('aria-label',paused?'Play slideshow':'Pause slideshow')};dots.forEach((dot,i)=>dot.addEventListener('click',()=>show(i)));pause.addEventListener('click',()=>{paused=!paused;sync()});hero.addEventListener('pointerdown',e=>{down={x:e.clientX,y:e.clientY};dragged=false});hero.addEventListener('pointerup',e=>{if(!down)return;const dx=e.clientX-down.x,dy=e.clientY-down.y;down=null;if(Math.abs(dx)>45&&Math.abs(dx)>Math.abs(dy)){dragged=true;show(idx+(dx<0?1:-1))}});hero.addEventListener('pointercancel',()=>down=null);hero.addEventListener('click',e=>{if(dragged){e.preventDefault();dragged=false}},true);let frame;function tick(now){if(!hero.isConnected){cancelAnimationFrame(frame);return}const dt=Math.min(now-last,100);last=now;const visible=hero.getBoundingClientRect().bottom>0&&hero.getBoundingClientRect().top<innerHeight;if(!paused&&!document.hidden&&!down&&visible&&!document.querySelector('dialog[open],.tingle-modal--visible')&&!hero.matches(':focus-within')){elapsed+=dt;if(elapsed>=6000)show(idx+1)}dots[idx]?.querySelector('.bv3-ring')?.style.setProperty('stroke-dashoffset',String(44*(1-elapsed/6000)));frame=requestAnimationFrame(tick)}sync();frame=requestAnimationFrame(tick);hero.addEventListener('shopify:block:select',e=>{const slide=e.target.closest('[data-bv3-slide]');if(slide){show(slides.indexOf(slide));paused=true;sync()}})}
 function setupBenefits(host){
 if(host.dataset.bv3Bound)return;host.dataset.bv3Bound='1';
 const slides=[...host.querySelectorAll('[data-bv3-benefit]')],dots=[...host.querySelectorAll('[data-bv3-benefit-dot]')],rings=dots.map(d=>d.querySelector('.bv3-benefit-timer circle')),reduced=matchMedia('(prefers-reduced-motion:reduce)');
 if(!slides.length)return;
 let idx=0,elapsed=0,last=performance.now(),frame;
 const show=i=>{idx=(i+slides.length)%slides.length;elapsed=0;slides.forEach((s,n)=>s.hidden=n!==idx);dots.forEach((d,n)=>d.setAttribute('aria-pressed',String(n===idx)));rings.forEach(r=>{if(r)r.style.strokeDashoffset='1'})};
 dots.forEach((d,i)=>d.addEventListener('click',()=>show(i)));
 function tick(now){
 if(!host.isConnected)return;
 const dt=Math.min(now-last,100);last=now;
 const box=host.getBoundingClientRect();
 if(!reduced.matches&&!document.hidden&&box.bottom>0&&box.top<innerHeight&&!host.matches(':hover,:focus-within')&&slides.length>1){elapsed+=dt;if(elapsed>=5000)show(idx+1)}
 if(rings[idx])rings[idx].style.strokeDashoffset=String(1-elapsed/5000);
 frame=requestAnimationFrame(tick);
 }
 show(0);frame=requestAnimationFrame(tick);
 }
 function prune(){document.querySelectorAll('header a[href],footer a[href],.bo-nav-popover a[href],.footer a[href]').forEach(a=>{if(a.closest('[data-bx-navigation]'))return;if(a.closest('[data-bx-navigation]'))return;const href=a.getAttribute('href')||'';if(/track\s*(?:your\s*)?order|size\s*(?:guide|chart)/i.test(a.textContent)||/\/(?:pages|apps)\/(?:size-chart|size-guide|track-order|track-your-order|tracking)(?:[/?#]|$)/i.test(href)){(a.closest('li')||a).remove()}});if(location.pathname.includes('/pages/md-help-center')){document.querySelectorAll('a[href]').forEach(a=>{if(/size.chart|size.guide|track.order|track.your.order/i.test(a.getAttribute('href')||''))(a.closest('li')||a).remove()});document.querySelectorAll('section[id]').forEach(s=>{if(/size.?guide|size.?chart|track.?order/i.test(s.id))s.remove()})}}


 const colourRows=new WeakSet(),colourWidths=new WeakMap(),pendingColours=new Set();
 let colourFrame=0;
 function measureColourRow(row){
  if(!row.isConnected)return null;
  const photos=[...row.querySelectorAll(':scope > a')],more=row.querySelector('[data-bv3-colours-more]'),width=row.clientWidth;
  if(!more||!photos.length||!width)return null;
  const style=getComputedStyle(row),gap=parseFloat(style.columnGap)||0,available=width-(parseFloat(style.paddingLeft)||0)-(parseFloat(style.paddingRight)||0),photoWidth=photos[0].getBoundingClientRect().width||36;
  const moreStyle=getComputedStyle(more),moreWidth=parseFloat(moreStyle.flexBasis)||parseFloat(moreStyle.width)||24;
  const allFit=photos.length*photoWidth+Math.max(0,photos.length-1)*gap<=available;
  const visible=allFit?photos.length:Math.max(1,Math.floor((available-moreWidth)/(photoWidth+gap)));
  return {row,photos,more,visible,remaining:photos.length-visible,expanded:row.dataset.expanded==='true'};
 }
 function applyColourRow(state){
  if(!state)return;
  const {row,photos,more,visible,remaining,expanded}=state;
  photos.forEach((photo,i)=>{const hidden=!expanded&&i>=visible;if(photo.hidden!==hidden)photo.hidden=hidden});
  if(more.hidden!==(remaining===0))more.hidden=remaining===0;
  const text=expanded?'−':'+'+remaining,label=row.getAttribute('aria-label')+(expanded?'':' +'+remaining);
  if(more.textContent!==text)more.textContent=text;
  if(more.getAttribute('aria-expanded')!==String(expanded))more.setAttribute('aria-expanded',String(expanded));
  if(more.getAttribute('aria-label')!==label)more.setAttribute('aria-label',label);
 }
 function queueColourRow(row){
  pendingColours.add(row);
  if(colourFrame)return;
  colourFrame=requestAnimationFrame(()=>{
   colourFrame=0;
   const states=[...pendingColours].map(measureColourRow);
   pendingColours.clear();
   states.forEach(applyColourRow);
  });
 }
 const colourResize=new ResizeObserver(entries=>entries.forEach(({target,contentRect})=>{
  if(colourWidths.get(target)===contentRect.width)return;
  colourWidths.set(target,contentRect.width);
  queueColourRow(target);
 }));
 function setupColourRows(scope=document){
  const rows=[...(scope.matches?.('[data-bv3-colours]')?[scope]:[]),...scope.querySelectorAll('[data-bv3-colours]')];
  rows.forEach(row=>{if(colourRows.has(row))return;colourRows.add(row);colourResize.observe(row);queueColourRow(row)});
 }
 document.addEventListener('click',event=>{const more=event.target.closest('[data-bv3-colours-more]');if(!more)return;const row=more.closest('[data-bv3-colours]');row.dataset.expanded=String(row.dataset.expanded!=='true');applyColourRow(measureColourRow(row))});
 function releaseColourRow(row){colourResize.unobserve(row);colourRows.delete(row);colourWidths.delete(row);pendingColours.delete(row)}
 const colourChanges=new MutationObserver(records=>records.forEach(record=>{
  record.removedNodes.forEach(node=>{if(node.nodeType!==1)return;if(node.matches('[data-bv3-colours]'))releaseColourRow(node);node.querySelectorAll('[data-bv3-colours]').forEach(releaseColourRow)});
  record.addedNodes.forEach(node=>{if(node.nodeType===1)setupColourRows(node)});
 }));
 colourChanges.observe(document.body,{childList:true,subtree:true});


 const compactHeaderMedia=matchMedia('(max-width:767px)');
 function placeMobileTopnav(){
  const header=document.querySelector('header.header');
  const nav=document.querySelector('.bv3-topnav');
  const section=header?.closest('.section-header');
  if(!header||!nav||!section)return;
  if(compactHeaderMedia.matches){
   if(nav.previousElementSibling!==section)section.after(nav);
  }else if(nav.parentElement!==header){header.append(nav)}
 }
 compactHeaderMedia.addEventListener('change',placeMobileTopnav);

 function init(){setupColourRows();document.querySelectorAll('[data-action="toggle-nav"]').forEach(b=>b.dataset.action='bv3-toggle-nav');document.querySelectorAll('[data-bv3-hero]').forEach(setupHero);document.querySelectorAll('[data-bv3-benefits]').forEach(setupBenefits);document.querySelectorAll('[data-bv3-look-form]').forEach(total);const header=document.querySelector('header.header'),tpl=document.querySelector('[data-bv3-topnav]');if(header&&tpl&&!document.querySelector('.bv3-topnav'))header.append(tpl.content.cloneNode(true));placeMobileTopnav();const menu=document.getElementById('bv3-menu');if(menu&&!menu.dataset.bound){menu.dataset.bound='1';menu.addEventListener('click',e=>{const r=menu.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right)menu.close()})}showLook();prune()}
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();document.addEventListener('shopify:section:load',init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["broek-video-looks"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('broek-video-looks'))customElements.define('broek-video-looks',class extends HTMLElement{
 connectedCallback(){if(this.bound)return;this.bound=true;this.abort=new AbortController();const opts={signal:this.abort.signal};const track=this.querySelector('.bvl-track'),dialog=this.querySelector('dialog'),video=this.querySelector('video'),shop=this.querySelector('.bvl-shop'),error=this.querySelector('.bvl-error');let opener;
 this.querySelector('[data-bvl-prev]').addEventListener('click',()=>track.scrollBy({left:-track.clientWidth*.8}),opts);this.querySelector('[data-bvl-next]').addEventListener('click',()=>track.scrollBy({left:track.clientWidth*.8}),opts);
 this.querySelectorAll('.bvl-open').forEach(button=>button.addEventListener('click',()=>{opener=button;shop.replaceChildren(button.closest('article').querySelector('template').content.cloneNode(true));error.hidden=true;video.poster=button.querySelector('img')?.currentSrc||'';video.src=matchMedia('(max-width:767px)').matches?button.dataset.bvlMobileSrc:button.dataset.bvlSrc;dialog.showModal();video.play().catch(()=>{});},opts));
 this.querySelector('.bvl-close').addEventListener('click',()=>dialog.close(),opts);dialog.addEventListener('click',event=>{if(event.target===dialog){const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close();}},opts);dialog.addEventListener('close',()=>{video.pause();video.removeAttribute('src');video.load();shop.replaceChildren();opener?.focus({preventScroll:true});},opts);video.addEventListener('error',()=>{error.hidden=false;},opts);document.addEventListener('visibilitychange',()=>{if(document.hidden)video.pause();},opts);
 }
 disconnectedCallback(){this.querySelector('video')?.pause();this.abort?.abort();this.bound=false;}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-bar"] && !Shopify.designMode) return;
  try {
    
  let top_bar = document.querySelector('.section-top-bar')?.clientHeight || 0;
  const body = document.querySelector('body');
  body.style.setProperty('--height-topbar', `${top_bar}px`);

  } catch(e) { console.error(e); }
})();
})();
